import { createSlice, createAction, PayloadAction } from "@reduxjs/toolkit";
import { keyBy } from "lodash";

// Trigger action for saga compatibility (saga watches this)
export const fetchAppMeta = createAction<any>("appMeta/trigger");

interface AppMetaState {
  data: {
    allowedHtml: Record<string, any>;
    docbuilderQuestionTypes: Record<string, any>;
    gradeLevels: Record<string, any>;
    languages: Record<string, any>;
    materials: Record<string, any>;
    organizationRoles: Record<string, any>;
    organizationTypes: Record<string, any>;
    responseStructures: Record<string, any>;
    resourceTypes: Record<string, any>;
    userFunctions: Record<string, any>;
    userFunctionCategories: Record<string, any>;
    systemRoles: Record<string, any>;
  };
  loading: boolean;
  loaded: boolean;
  failed: boolean;
}

const initialState: AppMetaState = {
  data: {
    allowedHtml: {},
    docbuilderQuestionTypes: {},
    gradeLevels: {},
    languages: {},
    materials: {},
    organizationRoles: {},
    organizationTypes: {},
    responseStructures: {},
    resourceTypes: {},
    userFunctions: {},
    userFunctionCategories: {},
    systemRoles: {},
  },
  loading: false,
  loaded: false,
  failed: false,
};

const appMetaSlice = createSlice({
  name: "appMeta",
  initialState,
  reducers: {
    fetchAppMetaStart(state) {
      state.loading = true;
      state.failed = false;
    },
    fetchAppMetaSuccess(state, action: PayloadAction<any>) {
      const payload = action.payload;
      state.loaded = true;
      state.loading = false;
      state.failed = false;
      state.data = {
        allowedHtml: payload["allowed-html"],
        docbuilderQuestionTypes: keyBy(payload.docbuilder_question_types, "id"),
        gradeLevels: keyBy(payload.grade_levels, "id"),
        languages: keyBy(payload.languages, "id"),
        materials: payload["materials"],
        organizationRoles: keyBy(payload.organization_roles, "id"),
        organizationTypes: keyBy(payload.organization_types, "id"),
        responseStructures: keyBy(payload.response_structures, "id"),
        resourceTypes: keyBy(payload.resource_types, "id"),
        userFunctions: keyBy(payload.user_functions, "id"),
        userFunctionCategories: keyBy(payload.user_function_categories, "id"),
        systemRoles: keyBy(payload.system_roles, "id"),
      };
    },
    fetchAppMetaFailure(state) {
      state.loading = false;
      state.failed = true;
    },
  },
});

export const { fetchAppMetaStart, fetchAppMetaSuccess, fetchAppMetaFailure } =
  appMetaSlice.actions;

export default appMetaSlice.reducer;
